import { render, staticRenderFns } from "./TouchScreenNotes.vue?vue&type=template&id=787a70b3&scoped=true&"
import script from "./TouchScreenNotes.vue?vue&type=script&lang=js&"
export * from "./TouchScreenNotes.vue?vue&type=script&lang=js&"
import style0 from "./TouchScreenNotes.vue?vue&type=style&index=0&id=787a70b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787a70b3",
  null
  
)

export default component.exports